<template>
<div class="home page-template-default page separate-containers nav-below-header dropdown-hover">
  <HeadNav selectedLanguage="en" page="home" :gotodownload="goDownload" :apk="apk" />

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">

          <section class="entry-wrapper hero hero-stage">
            <div class="hero-stage__glow" aria-hidden="true" />

            <div class="hero-shell hero-shell--stage">
              <div class="hero-stage__panel">
              <div class="hero-stage__logo">
                <img
                  class="hero-stage__logo-img"
                  src="@/assets/gbwa-logo.webp"
                  alt="GB WhatsApp Pro"
                  width="128"
                  height="128"
                  loading="eager"
                  decoding="async"
                >
              </div>

              <header class="hero-top hero-top--stage">
                <p class="hero-kicker">{{ hero.kicker }}</p>
                <h1>{{ hero.h1 }}</h1>
              </header>

              <p class="hero-stage__lead" v-html="hero.intro" />

              <ul class="hero-trust" aria-label="App snapshot">
                <li v-for="(item, ti) in heroTrust" :key="ti" class="hero-trust__item">
                  <span class="hero-trust__value">{{ item.value }}</span>
                  <span class="hero-trust__label">{{ item.label }}</span>
                </li>
              </ul>

              <div class="hero-stage__actions">
                <button type="button" class="hero-download-btn hero-download-btn--stage" @click="goDownload">
                  <img class="hero-download-icon" src="@/assets/android.webp" alt="" aria-hidden="true">
                  <span>Download GB WhatsApp Pro APK</span>
                </button>
                <a href="/features/" class="hero-secondary-btn hero-secondary-btn--stage">Explore features</a>
              </div>

              <p class="hero-cta-hint hero-cta-hint--stage">Free download for Android 5.0 and above</p>
              <p class="hero-unofficial-note hero-unofficial-note--stage">{{ hero.disclaimer }}</p>
              </div>

              <ul class="hero-badges hero-badges--stage" aria-label="Highlights">
                <li class="hero-badge">🔒 Privacy controls</li>
                <li class="hero-badge">🎨 Custom themes</li>
                <li class="hero-badge">📁 Larger media</li>
                <li class="hero-badge">📥 Status tools</li>
              </ul>
            </div>
          </section>

          <template v-for="(block, bi) in homeSections">
            <div :key="'sec-' + bi" class="section-content">
              <h2 v-if="block.h2" class="h">{{ block.h2 }}</h2>
              <p v-for="(p, pi) in block.paragraphs || []" :key="'bp' + pi" v-html="p" />

              <div
                v-for="(uc, ui) in block.useCaseBlocks || []"
                :key="'uc' + ui"
                class="home-use-case"
              >
                <h3 class="home-section-h3">{{ uc.h3 }}</h3>
                <p v-html="uc.text" />
              </div>

              <div v-if="block.detailsTable" class="details-table">
                <table>
                  <tbody>
                    <tr v-for="(row, i) in appDetails" :key="i">
                      <th>{{ row.label }}</th>
                      <td>{{ row.value }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-if="block.featureCategories" class="explore-grid">
                <a
                  v-for="card in featureCategoryCards"
                  :key="card.href"
                  class="explore-card"
                  :href="card.href"
                >
                  <span class="explore-card__icon" aria-hidden="true">{{ card.icon }}</span>
                  <strong>{{ card.label }}</strong>
                  <span>{{ card.desc }}</span>
                </a>
              </div>

              <div v-if="block.tableKey === 'comparison'" class="compare-table-wrap">
                <table class="compare-table">
                  <thead>
                    <tr>
                      <th v-for="(h, hi) in comparisonTable.headers" :key="hi">{{ h }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, ri) in comparisonTable.rows" :key="ri">
                      <td v-for="(cell, ci) in row" :key="ci">{{ cell }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <ul v-if="block.list" class="check-list">
                <li v-for="(item, li) in block.list" :key="'li' + li" v-html="item" />
              </ul>

              <div v-if="block.linkCards" class="explore-grid">
                <a
                  v-for="card in block.linkCards"
                  :key="card.href"
                  class="explore-card"
                  :href="card.href"
                >
                  <span v-if="card.icon" class="explore-card__icon" aria-hidden="true">{{ card.icon }}</span>
                  <strong>{{ card.label }}</strong>
                  <span>{{ card.desc }}</span>
                </a>
              </div>

              <ol v-if="block.steps" class="step-cards">
                <li v-for="(step, si) in block.steps" :key="si" v-html="step" />
              </ol>

              <div v-if="block.safetyPanel" class="safety-panel">
                Nobody can promise that a modded WhatsApp file is completely safe or that your account will never be flagged. Back up chats before you install or update, and read the safety section if you are unsure.
              </div>

              <div v-if="block.troubleKey === 'cards'" class="trouble-grid">
                <a v-for="(card, ti) in troubleCards" :key="ti" class="trouble-card" :href="card.href">
                  <strong>{{ card.title }}</strong>
                  <span>{{ card.text }}</span>
                </a>
              </div>

              <div v-if="block.cta" class="final-cta-row">
                <a href="/download/" class="final-cta-btn final-cta-btn--primary">Go to download</a>
                <a href="/installation/" class="final-cta-btn final-cta-btn--secondary">Installation guide</a>
              </div>
            </div>
          </template>

          <div class="section-content">
            <h2 class="h">{{ homeFaqSection.h2 }}</h2>
            <p class="faq-section-lead">{{ homeFaqSection.lead }}</p>
            <FAQ :faqs="homeFaqItems" />
            <p class="faq-home-more">
              <a href="/faq/" class="faq-home-more__link">View full FAQ page</a>
            </p>
          </div>

          <div class="section-content">
            <h2 class="h">{{ homeFinalSection.h2 }}</h2>
            <p v-for="(p, pi) in homeFinalSection.paragraphs" :key="'fin' + pi" v-html="p" />
            <div class="final-cta-row">
              <button type="button" class="final-cta-btn final-cta-btn--primary" @click="goDownload">
                <img class="final-cta-btn__icon" src="@/assets/android.webp" alt="" aria-hidden="true">
                <span>Download GB WhatsApp Pro APK</span>
              </button>
              <a href="/installation/" class="final-cta-btn final-cta-btn--secondary">Installation guide</a>
            </div>
          </div>

        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import '@/css/gb-home-layout.scss'
import '@/css/gbwhatpro-sections.scss'
import '@/css/guide-pages.scss'
import HeadNav from '@/components/HeadNav.vue'
import FAQ from '@/components/FAQ.vue'
import {
	appDetails,
	hero,
	heroTrust,
	featureCategoryCards,
	comparisonTable,
	homeSections,
	homeFaqSection,
	homeFaqItems,
	homeFinalSection,
	troubleCards,
} from '@/data/homeContent'

export default {
	name: 'Home',
	components: { HeadNav, FAQ },
	data() {
		return {
			apk: null,
			appDetails,
			hero,
			heroTrust,
			featureCategoryCards,
			comparisonTable,
			homeSections,
			homeFaqSection,
			homeFaqItems,
			homeFinalSection,
			troubleCards,
		}
	},
	mounted() {
		this.resolveApk()
	},
	methods: {
		resolveApk() {
			if (typeof window !== 'undefined' && window.initData?.settings) {
				// SSR 注入的 init 数据在客户端可用时使用
			}
			this.apk = process.env.VUE_APP_DEFAULT_APK || process.env.VUE_APP_GBLINK
			if (this.$server?.getOfficalApk) {
				this.$server
					.getOfficalApk({ domain: 'gbwhatsapp.download', appName: 'GB' })
					.then((res) => {
						if (res.code === 200 && res.data?.apk) {
							this.apk = res.data.apk
						}
					})
					.catch(() => {})
			}
		},
		goDownload() {
			if (this.apk) {
				this.$global.download(this.apk)
			} else {
				this.$router.push('/download/')
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.home-section-h3 {
	margin: 1.35em 0 0.45em;
	font-size: 1.125rem;
	font-weight: 700;
	color: #075e54;
	text-align: left;
	line-height: 1.35;

	&:first-of-type {
		margin-top: 0.75em;
	}
}

.faq-section-lead {
	margin: 0 0 1.1em;
	text-align: center;
	font-size: 0.9375rem;
	line-height: 1.6;
	color: #64748b;
}

.faq-home-more {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	gap: 12px 20px;
	margin-top: 1.25em;
	text-align: center;
}

.faq-home-more__btn {
	padding: 10px 18px;
	font-size: 0.9375rem;
	font-weight: 600;
	color: #075e54;
	background: #ecfdf5;
	border: 1px solid rgba(18, 140, 126, 0.28);
	border-radius: 8px;
	cursor: pointer;

	&:hover {
		background: #d1fae5;
	}
}

.faq-home-more__link {
	font-size: 0.9375rem;
	font-weight: 600;
	color: #128c7e;
	text-decoration: none;

	&:hover {
		text-decoration: underline;
	}
}
</style>
